import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { questKeys } from '../quests.keys';
import { listCreatorQuests } from '../quests.service';
export const useCreatorQuests = (limit = 10, initialData) => {
    return useInfiniteQuery({
        queryKey: questKeys.creatorQuests(limit),
        queryFn: ({ pageParam }) => {
            return listCreatorQuests(pageParam, limit);
        },
        getNextPageParam: lastPage => {
            if (lastPage.nextCursor) {
                return lastPage.nextCursor;
            }
            return undefined;
        },
        retry: 3,
        placeholderData: keepPreviousData,
        initialPageParam: null,
        initialData: initialData
            ? {
                pages: [initialData],
                pageParams: [null],
            }
            : undefined,
        staleTime: 30000,
    });
};
